import { render, staticRenderFns } from "./AssetUsed.vue?vue&type=template&id=72bc993f&scoped=true&"
import script from "./AssetUsed.vue?vue&type=script&lang=js&"
export * from "./AssetUsed.vue?vue&type=script&lang=js&"
import style0 from "./AssetUsed.vue?vue&type=style&index=0&id=72bc993f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72bc993f",
  null
  
)

export default component.exports